import {useStoreActions, useStoreState} from 'easy-peasy';
import {fetchSelfInfo, fetchUsersBulkInfo} from 'providers/core/users';
import {queryCache, useQuery} from 'react-query';
import _ from 'lodash';
import {getPushMessage} from '../views/extera/pushStorage';

export function useSelfInfo(queryConfig) {
  const selfInfo = useStoreState((state) => state.auth.selfInfo);
  const setSelfInfo = useStoreActions((actions) => actions.auth.setSelfInfo);
  const updateSelfInfo = useStoreActions(
    (actions) => actions.auth.updateSelfInfo,
  );
  const loggedIn = useStoreState((state) => state.auth.loggedIn);

  useQuery(
    'selfInfo',
    async () => {
      const {data} = await fetchSelfInfo();
      setSelfInfo(data);
      getPushMessage(updateSelfInfo);
      return data;
    },
    {
      enabled: loggedIn,
      staleTime: 15 * 60 * 1000,
      cacheTime: Infinity,
      ...queryConfig,
    },
  );

  const query = useQuery(
    'selfInfo',
    async () => {
      const {data} = await fetchSelfInfo();
      setSelfInfo(data);
      getPushMessage(updateSelfInfo);
      return data;
    },
    {
      enabled: loggedIn,
      staleTime: 15 * 60 * 1000,
      cacheTime: Infinity,
      ...queryConfig,
    },
  );

  return {
    selfInfo,
    setSelfInfo,
    updateSelfInfo,
    ...query,
  };
}

const userStaleTime = Infinity;

export function useUser(id) {
  const queryKey = ['users', id];

  return useQuery(
    queryKey,
    async () => {
      const resolved = await resolveUsers([id]);
      return resolved[id] || null;
    },
    {
      staleTime: userStaleTime,
    },
  );
}

export function putUsersInCache(user) {
  const queryKey = ['users', user.user.userId];
  queryCache.setQueryData(queryKey, user, {
    staleTime: userStaleTime,
  });
}

export async function resolveUsers(userIds) {
  const resolvedUsers = {};

  if (!userIds || !userIds?.length) {
    return resolvedUsers;
  }

  const uniqueIds = _.uniq(userIds);
  const chunks = _.chunk(uniqueIds, 100);
  for (const chunk of chunks) {
    const {users} = await fetchUsersBulkInfo(chunk);

    for (const user of users) {
      putUsersInCache(user);
      resolvedUsers[user.user.userId] = user;
    }
  }

  for (const userId of userIds) {
    if (!resolvedUsers.hasOwnProperty(userId)) {
      putUsersInCache(null);
      resolvedUsers[userId] = null;
    }
  }

  return resolvedUsers;
}
